import * as D from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { t } from "@shared/i18n";

/** Panneau latéral (plein écran sur mobile). */
export function Sheet({ open, onOpenChange, title, description, children, footer, className }: { open: boolean; onOpenChange: (o: boolean) => void; title: string; description?: ReactNode; children: ReactNode; footer?: ReactNode; className?: string }) {
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      <D.Portal>
        <D.Overlay className="anim-overlay fixed inset-0 z-50 bg-black/40 backdrop-blur-[3px]" />
        <D.Content className={cn("anim-sheet glass-pop fixed inset-x-0 bottom-0 top-[max(env(safe-area-inset-top),24px)] z-50 flex w-full flex-col !rounded-b-none !rounded-t-[28px] sm:inset-y-0 sm:left-auto sm:right-0 sm:top-0 sm:max-w-lg sm:!rounded-none sm:!rounded-l-[28px] sm:pt-safe", className)}>
          <div className="mx-auto mt-2 h-1.5 w-10 shrink-0 rounded-full bg-border-strong sm:hidden" aria-hidden />
          <div className="flex items-start justify-between gap-4 border-b border-border/70 px-5 py-4">
            <div className="min-w-0">
              <D.Title className="truncate text-[17px] font-bold">{title}</D.Title>
              {description ? <D.Description className="mt-0.5 text-sm text-muted">{description}</D.Description> : <D.Description className="sr-only">{title}</D.Description>}
            </div>
            <D.Close className="press flex size-8 items-center justify-center rounded-full bg-surface text-muted hover:text-fg" aria-label={t("Fermer")}>
              <X className="size-4" />
            </D.Close>
          </div>
          <div className="scrollbar-thin flex-1 overflow-y-auto px-5 py-5">{children}</div>
          {footer && <div className="pb-safe border-t border-border/70 px-5 py-3">{footer}</div>}
        </D.Content>
      </D.Portal>
    </D.Root>
  );
}
